import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('admin/cash_desks', [
    '~FETCH_CASH_DESKS',
    '~PREPARE_FILTER',

    /** EDIT ACTIONS */
    'EDIT',
    'TOGGLE_EDIT_MODAL',
    'SUBMIT_EDIT',
    /** */
]);

export const ACTION = actions(TYPE);
